import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

function Carousel() {
    useEffect(() => {
        const carouselElement = document.querySelector('#hero-carousel');
        if (carouselElement) {
            new window.bootstrap.Carousel(carouselElement, {
                interval: 7000,       // Increased from 5000 to 7000ms
                ride: 'carousel',
                pause: false,
            });
        }
    }, []);

    return (
        <section id="hero" className="hero section dark-background" style={{ position: 'relative' }}>
            <div 
                id="hero-carousel" 
                className="carousel slide carousel-fade" 
                data-bs-ride="carousel" 
                data-bs-interval="7000"          // Also updated to 7000ms
            >
                <div className="carousel-inner" style={{ height: '80vh' }}>
                    {/* Slide 1: Introduction */}
                    <div className="carousel-item active">
                        <img
                            src="assets/img/hero-carousel/slider-1.png"   // Replace with your computer/tech image
                            alt="Computer Repair"
                            className="d-block w-100"
                            style={{ objectFit: 'cover' }}
                        />
                        {/* <div
                            className="carousel-container d-flex flex-column justify-content-center align-items-center"
                            style={{
                                position: 'absolute',
                                top: 0,
                                bottom: 0,
                                left: 0,
                                right: 0,
                                color: '#fff',
                                textAlign: 'center',
                            }}
                        >
                            <h2>GANPATI COMPUTERS</h2>
                            <p>Your Trusted Computer & Printer Repair Experts in Ropar</p>
                            <p>Hardware • Software • AMC • Networking • Spare Parts</p>
                            <p>
                                Call us: <a href="tel:9988893537">99888-93537</a>
                            </p>
                            <Link
                                to="/#contact"
                                className="btn-get-started"
                                style={{
                                    backgroundColor: '#007bff',
                                    color: '#fff',
                                    padding: '10px 20px',
                                    borderRadius: '5px',
                                    textDecoration: 'none',
                                }}
                            >
                                Get in Touch
                            </Link>
                        </div> */}
                    </div>

                    {/* Slide 2: Offers */}
                    <div className="carousel-item">
                        <img
                            src="assets/img/hero-carousel/slider-2.png"   // Replace with tech/offer image
                            alt="Special Offers"
                            className="d-block w-100"
                            style={{ objectFit: 'cover' }}
                        />
                        {/* <div
                            className="carousel-container d-flex flex-column justify-content-center align-items-center"
                            style={{
                                position: 'absolute',
                                top: 0,
                                bottom: 0,
                                left: 0,
                                right: 0,
                                color: '#fff',
                                textAlign: 'center',
                            }}
                        >
                            <h2>Special Offers</h2>
                            <p>✔ SSD Upgrade – Starting ₹1999</p>
                            <p>✔ Printer Repair – Free Diagnosis</p>
                            <p>✔ Data Recovery – 10% Off</p>
                            <p>✔ AMC Plans – Customized for Businesses</p>
                            <p>Visit our shop or call for details</p>
                        </div> */}
                    </div>

                    {/* Slide 3: Location & Contact */}
                    <div className="carousel-item">
                        <img
                            src="assets/img/hero-carousel/slider-3.png"   // Replace with location/tech image
                            alt="Visit Us"
                            className="d-block w-100"
                            style={{ objectFit: 'cover' }}
                        />
                        <div
                            className="carousel-container d-flex flex-column justify-content-center align-items-center"
                            style={{
                                position: 'absolute',
                                top: 0,
                                bottom: 0,
                                left: 0,
                                right: 0,
                                color: '#fff',
                                textAlign: 'center',
                            }}
                        >
                            <h2>Visit Our Shop</h2>
                            <p>
                                <strong>Nau Gaja Peer, College Road, Ropar</strong>
                            </p>
                            <p>Mon–Sat: 10:00 AM – 8:00 PM | Sunday Closed</p>
                            <p>
                                Call: <a href="tel:9988893537">99888-93537</a> &nbsp; | &nbsp;
                                Email: <a href="mailto:info@ganpaticomputers.com">info@ganpaticomputers.com</a>
                            </p>
                        </div>
                    </div>
                </div>

                <a className="carousel-control-prev" href="#hero-carousel" role="button" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon bi bi-chevron-left" aria-hidden="true"></span>
                </a>

                <a className="carousel-control-next" href="#hero-carousel" role="button" data-bs-slide="next">
                    <span className="carousel-control-next-icon bi bi-chevron-right" aria-hidden="true"></span>
                </a>

                <ol className="carousel-indicators">
                    <li data-bs-target="#hero-carousel" data-bs-slide-to="0" className="active"></li>
                    <li data-bs-target="#hero-carousel" data-bs-slide-to="1"></li>
                    <li data-bs-target="#hero-carousel" data-bs-slide-to="2"></li>
                </ol>
            </div>
        </section>
    );
}

export default Carousel;